(function(){
  if (window.__vytaGuideToggleInit) return;
  window.__vytaGuideToggleInit = true;
  var VID = 53116279914824;
  var HANDLE = 'the-lymphatic-reset-workbook-free-pdf-guide';
  var PDF = 'https://cdn.shopify.com/s/files/1/0945/0107/7320/files/vyta-21-day-lymphatic-reset-workbook.pdf?v=1779740597';
  var IMG = 'https://cdn.shopify.com/s/files/1/0945/0107/7320/files/vyta-workbook-cart-thumbnail-v4.png?v=1780147718';
  var PROP_KEY = 'Free guide download';
  var DISMISS_KEY = 'vyta_workbook_dismissed';
  var BUSY = false, observer;

  function R(){ return (window.routes || {}); }

  function isDismissed(){
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch(e){ return false; }
  }
  function setDismissed(v){
    try {
      if (v) sessionStorage.setItem(DISMISS_KEY, '1');
      else sessionStorage.removeItem(DISMISS_KEY);
    } catch(e){}
  }

  async function cartReq(url, payload){
    payload.sections = ['cart-drawer','cart-icon-bubble'];
    payload.sections_url = window.location.pathname;
    var res = await fetch(url, {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(payload)
    });
    var state = await res.json();
    var cd = document.querySelector('cart-drawer');
    if (cd && state && state.sections && typeof cd.renderContents === 'function'){
      cd.renderContents(state);
    }
    return state;
  }

  async function getCart(){
    try { var r = await fetch('/cart.js', {headers:{'Accept':'application/json'}}); return await r.json(); }
    catch(e){ return null; }
  }

  function guideLine(cart){
    if (!cart || !cart.items) return null;
    for (var i=0;i<cart.items.length;i++){ if (cart.items[i].variant_id === VID) return cart.items[i]; }
    return null;
  }

  async function addGuide(){
    return cartReq(R().cart_add_url, { id: VID, quantity: 1 });
  }

  function hideGuideRow(){
    var cd = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!cd) return;
    var links = cd.querySelectorAll('a[href*="' + HANDLE + '"]');
    for (var i=0;i<links.length;i++){
      var el = links[i];
      while (el && el !== cd){
        var isRow = el.tagName === 'TR'
          || (el.classList && (el.classList.contains('cart-item') || el.classList.contains('cart-items__table-row')))
          || (el.id && el.id.indexOf('CartItem') === 0)
          || (el.id && el.id.indexOf('CartDrawer-Item') === 0);
        if (isRow){ el.style.display = 'none'; el.setAttribute('data-vyta-hidden','1'); break; }
        el = el.parentElement;
      }
    }
  }

  function buildRow(checked){
    var w = document.createElement('div');
    w.id = 'vyta-guide-toggle';
    w.innerHTML =
      '<label class="vyta-gift" style="display:flex;align-items:center;gap:12px;padding:12px;margin:0 0 10px;border:1px solid #d8d0b8;border-radius:12px;background:#FFFFFF;cursor:pointer;box-shadow:0 1px 4px rgba(31,59,42,.07);">' +
        '<img src="' + IMG + '" alt="" width="52" height="52" style="width:52px;height:52px;object-fit:cover;border-radius:6px;background:#FFFFFF;flex:0 0 52px;">' +
        '<span style="flex:1;display:flex;flex-direction:column;line-height:1.25;gap:2px;">' +
          '<span style="font-size:10px;font-weight:700;color:#43A454;letter-spacing:.09em;text-transform:uppercase;">Yours free · worth $19</span>' +
          '<strong style="font-size:13px;color:#1F3B2A;font-weight:700;line-height:1.2;">The 21-Day Lymphatic Reset Workbook</strong>' +
        '</span>' +
        '<input type="checkbox" class="vyta-gift__cb" ' + (checked ? 'checked' : '') + ' style="width:22px;height:22px;accent-color:#43A454;flex:0 0 auto;cursor:pointer;">' +
      '</label>';
    return w;
  }

  function findAnchor(){
    var cd = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!cd) return null;
    return cd.querySelector('.totals.gb-discounts-cart-values')
        || cd.querySelector('.cart-drawer__footer')
        || cd.querySelector('#CartDrawer-Checkout');
  }

  async function sync(){
    if (BUSY) return;
    var cart = await getCart();
    if (!cart) return;
    var gl = guideLine(cart);
    var guideInCart = !!gl;
    var others = cart.items.filter(function(i){ return i.variant_id !== VID; });
    var existing = document.getElementById('vyta-guide-toggle');

    if (guideInCart) hideGuideRow();

    // Self-heal: stale property on existing guide line — swap for clean add
    if (gl && gl.properties && Object.keys(gl.properties).length && !BUSY){
      BUSY = true;
      try {
        await cartReq(R().cart_change_url, { id: gl.key, quantity: 0 });
        await addGuide();
      } finally { BUSY = false; }
      setTimeout(sync, 60);
      return;
    }

    if (others.length === 0){
      if (guideInCart && !BUSY){
        BUSY = true;
        try { await cartReq(R().cart_change_url, { id: gl.key, quantity: 0 }); }
        finally { BUSY = false; }
      }
      if (existing) existing.remove();
      return;
    }

    // The workbook is an Auto Refill perk, not a general freebie. It used to be auto-added to ANY
    // cart with items, so a one-time buyer saw "YOURS FREE · WORTH $19" they were never meant to get.
    // Gate it on the same condition as the brush and stone: a subscription line must be present.
    var hasSubscription = cart.items.some(function(i){
      return !!(i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) || !!i.selling_plan;
    });

    if (!hasSubscription){
      if (guideInCart && !BUSY){
        BUSY = true;
        try { await cartReq(R().cart_change_url, { id: gl.key, quantity: 0 }); }
        finally { BUSY = false; }
        setTimeout(sync, 60);
      }
      if (existing) existing.remove();
      return;
    }

    // AUTO-ADD workbook when cart has items and user hasn't explicitly dismissed it
    if (!guideInCart && !isDismissed() && !BUSY){
      BUSY = true;
      try { await addGuide(); }
      finally { BUSY = false; }
      setTimeout(sync, 60);
      return;
    }

    var anchor = findAnchor();
    if (!anchor){ if (existing) existing.remove(); return; }

    if (!existing){
      var row = buildRow(guideInCart);
      anchor.parentNode.insertBefore(row, anchor);
      row.querySelector('.vyta-gift__cb').addEventListener('change', onToggle);
    } else {
      var cb = existing.querySelector('.vyta-gift__cb');
      if (cb && cb.checked !== guideInCart) cb.checked = guideInCart;
      if (anchor.parentNode && existing.nextSibling !== anchor){
        anchor.parentNode.insertBefore(existing, anchor);
      }
    }
  }

  async function onToggle(e){
    var cb = e.target;
    cb.disabled = true; BUSY = true;
    try {
      if (cb.checked) {
        setDismissed(false);
        await addGuide();
      } else {
        setDismissed(true);
        var cart = await getCart();
        var line = guideLine(cart);
        if (line) await cartReq(R().cart_change_url, { id: line.key, quantity: 0 });
      }
    } catch(err){ console.error('VYTA guide toggle', err); }
    finally { BUSY = false; cb.disabled = false; setTimeout(sync, 60); }
  }

  function watch(){
    var cd = document.querySelector('cart-drawer');
    if (!cd){ setTimeout(watch, 300); return; }
    if (observer) observer.disconnect();
    observer = new MutationObserver(function(){
      if (window.__vytaRaf) cancelAnimationFrame(window.__vytaRaf);
      window.__vytaRaf = requestAnimationFrame(function(){ setTimeout(sync, 30); });
    });
    observer.observe(cd, {childList:true, subtree:true});
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('cart:refresh', function(){ setTimeout(sync, 80); });
})();

/* VYTA: bold ALL CTA button text on homepage + product page (incl. sticky ATC). */
(function(){
  var p = (location.pathname || '').replace(/\/+$/,'');
  var isHome = p === '' || /^\/[a-z]{2}(-[a-z]{2,3})?$/i.test(p);
  var isProduct = location.pathname.indexOf('/products/') !== -1;
  if (!isHome && !isProduct) return;

  var SEL = [
    '.shop-add-to-cart-button', '.shop-add-to-cart-wrapper',
    '.product-form__submit', '.shopify-payment-button__button',
    '.button-text', '.button-icon',
    '.custom-text-main-text-content',
    '[class*="sticky"] [class*="add-to-cart"]',
    '[class*="sticky-add-to-cart"] button', '[class*="sticky-add-to-cart"] a',
    'button.button', 'a.button', '.btn'
  ].join(',');

  function inCart(el){
    return !!(el.closest && el.closest('cart-drawer, #CartDrawer, #shopify-section-cart-drawer, #vyta-guide-toggle'));
  }

  function bold(root){
    var nodes = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++){
      var el = nodes[i];
      if (inCart(el)) continue;
      if (el.getAttribute('data-vyta-bold') === '1') continue;
      el.style.setProperty('font-weight', '700', 'important');
      el.setAttribute('data-vyta-bold', '1');
      var kids = el.querySelectorAll('span, strong, b, p, div');
      for (var k = 0; k < kids.length; k++){
        kids[k].style.setProperty('font-weight', '700', 'important');
      }
    }
  }

  var raf;
  function schedule(){ if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(function(){ bold(); }); }

  function start(){
    bold();
    var obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true });
    var n = 0, iv = setInterval(function(){ bold(); if (++n >= 8) clearInterval(iv); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* VYTA: silent audit-stamp when the workbook is added. No UI. */
(function(){
  if (window.__vytaConsentInit) return;
  window.__vytaConsentInit = true;
  function R(){ return (window.routes || {}); }
  function stamp(){
    if (window.__vytaStamped) return;
    window.__vytaStamped = true;
    try {
      fetch((R().cart_update_url) || '/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ attributes: { 'vyta_email_consent': 'workbook-optin ' + new Date().toISOString() } })
      }).catch(function(){});
    } catch(e){}
  }
  function attach(){
    var box = document.getElementById('vyta-guide-toggle');
    if (!box || box.getAttribute('data-vyta-stamp-bound') === '1') return;
    var gcb = box.querySelector('.vyta-gift__cb');
    if (!gcb) return;
    box.setAttribute('data-vyta-stamp-bound','1');
    if (gcb.checked) stamp();
    gcb.addEventListener('change', function(){ if (gcb.checked) stamp(); });
  }
  function boot(){
    var cd = document.querySelector('cart-drawer');
    if (!cd){ setTimeout(boot, 300); return; }
    attach();
    new MutationObserver(function(){
      if (window.__vytaConsentRaf) cancelAnimationFrame(window.__vytaConsentRaf);
      window.__vytaConsentRaf = requestAnimationFrame(attach);
    }).observe(cd, { childList:true, subtree:true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();